import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiPhone } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { getSiteConfig } from '../../utils/siteConfig';

const ArrowIcon = FiArrowRight as React.ComponentType<{ className?: string }>;
const PhoneIcon = FiPhone as React.ComponentType<{ className?: string }>;

const Getstarted: React.FC = () => {
  const { t } = useTranslation();
  const siteConfig = getSiteConfig();
  const primaryPhoneNumber = siteConfig.phoneNumbers[0];

  return (
    <section className="relative py-28 overflow-hidden bg-gradient-to-br from-teal-600 via-teal-700 to-[#0A1628]">
      {/* <div className="pointer-events-none absolute -bottom-24 left-0 h-80 w-80 rounded-full bg-[#25d0c3]/15 blur-[130px]" />
      <div className="pointer-events-none absolute -right-24 top-16 h-80 w-80 rounded-full bg-[#0b3357]/30 blur-[130px]" /> */}

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <p className="text-teal-200/60 text-xs font-bold uppercase tracking-[0.2em] mb-4">
          {t('getStartedSection.eyebrow')}
        </p>

        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight leading-tight">
          {t('getStartedSection.titleLine1')}
          <br className="hidden sm:block" />
          {t('getStartedSection.titleLine2')}
        </h2>

        <p className="text-white/50 mt-6 text-lg max-w-xl mx-auto font-light leading-relaxed">
          {t('getStartedSection.description')}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-10">
          <Link
            to="/contact"
            className="inline-flex items-center justify-center bg-white text-teal-700 font-semibold px-8 py-4 transition-all text-sm hover:shadow-xl hover:-translate-y-0.5"
          >
            {t('getStartedSection.primaryCta')}
            <ArrowIcon className="h-5 w-5" />
          </Link>

          <a
            href={`tel:${primaryPhoneNumber.replace(/\s+/g, '')}`}
            className="inline-flex items-center justify-center border border-white/20 hover:border-white/40 text-white font-medium px-8 py-4 transition-all text-sm hover:bg-white/5"
          >
            <PhoneIcon className="h-5 w-5" />
            {primaryPhoneNumber}
          </a>
        </div>
      </div>
    </section>
  );
};

export default Getstarted;
